import { AppTooltipContainer } from "@1js/acui-tooltip";
import * as React from "react";
import { renderMenuButton_unstable } from "@fluentui/react-components";

import type { AppMenuButtonProps, AppMenuButtonState } from ".";

export const renderAppMenuButton = (
  state: AppMenuButtonState,
  props: AppMenuButtonProps
) => {
  return (
    <AppTooltipContainer {...props}>
      {renderMenuButton_unstable(state)}
    </AppTooltipContainer>
  );
};
